import type { Todo } from "../../domain/entities.ts";
import type { CreateTaskSaveMode } from "./task-panel-view.ts";

export interface TaskPanelStateOptions {
  saveMode: CreateTaskSaveMode;
  disclosures: Record<string, boolean>;
  reminderDefaults: Record<string, number[]>;
}

export class TaskPanelState {
  saveMode: CreateTaskSaveMode;
  lastTriggerId: string | null = null;
  moreOpen = false;
  draftRecovered = false;
  recoveredEditDraft: Todo | null = null;
  disclosures: Record<string, boolean>;
  reminderDefaults: Record<string, number[]>;

  constructor(options: TaskPanelStateOptions) {
    this.saveMode = options.saveMode;
    this.disclosures = options.disclosures;
    this.reminderDefaults = options.reminderDefaults;
  }

  reminderOffsets(rootId: string): number[] {
    return this.reminderDefaults[rootId] || [];
  }

  setReminderOffsets(rootId: string, offsets: number[]): void {
    this.reminderDefaults[rootId] = offsets;
  }

  setDisclosure(id: string, open: boolean): void {
    this.disclosures[id] = open;
  }
}
